import { useState } from "react";

import { TextToolState } from "@impero-com/ui";
import { Row } from "@tanstack/react-table";

import { useUpdateRiskDirectoryRightsForUserMutation } from "org/user/queries/useUpdateRiskDirectoryRightsForUserMutation";
import { UserOrUserGroupOverview } from "utils/user";

import { RiskDirectoryRow } from "./useUserRiskDirectoriesListTable";

interface UseReplaceRiskDirectoryUserUtilsProps {
    userId: number;
    selectedRows: Row<RiskDirectoryRow>[];
    deselectAll: () => void;
}

export function useReplaceRiskDirectoryUserUtils({
    userId,
    selectedRows,
    deselectAll,
}: UseReplaceRiskDirectoryUserUtilsProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { mutate, isPending, error, reset } =
        useUpdateRiskDirectoryRightsForUserMutation();

    const replaceUserToolState: TextToolState =
        selectedRows.length === 0 ? { type: "DISABLED" } : { type: "ENABLED" };

    const replaceUser = (userOrGroup: UserOrUserGroupOverview) => {
        const riskDirectoriesIds = selectedRows.map((row) => row.original.id);
        mutate(
            { userId, data: { newUserId: userOrGroup.id, riskDirectoriesIds } },
            {
                onSuccess: () => {
                    deselectAll();
                    setIsModalOpen(false);
                },
                // On failure the modal stays open; `error` drives the notice.
            }
        );
    };

    return {
        replaceUserToolState,
        isReplaceUserModalOpen: isModalOpen,
        replaceUserError: error,
        // Reset on open (not close) so the notice stays put during the close
        // animation and a stale error can't reappear next time.
        openReplaceUserModal: () => {
            reset();
            setIsModalOpen(true);
        },
        closeReplaceUserModal: () => setIsModalOpen(false),
        replaceUser,
        isReplacingUser: isPending,
    };
}
